package org.mkui.graphics

/**
 * Edge used by scan fill algorithm.
 *
 * @author Werner Randelshofer.
 * @version 1.0 April 5, 2006 Created.
 */
class Edge
/** Creates a new instance.  */
{
    /**
     * Upper value on y-axis for horizontal scan fill algorithm.
     * Upper value on x-axis for vertical scan fill algorithm.
     */
    var upper = 0

    /**
     * Intersection on x-axis for horizontal scan fill algorithm.
     * Intersection on y-axis for vertical scan fill algorithm.
     */
    var intersect = 0f

    /**
     * Delta-x per scan on y-axis for horizontal scan fill algorithm.
     * Delta-y per scan on x-axis for horizontal scan fill algorithm.
     */
    var dPerScan = 0f
    var next: Edge? = null
    override fun toString(): String {
        val buf: StringBuilder = StringBuilder()
        var e: Edge? = this
        while (e != null) {
            if (e !== this) buf.append(", ")
            buf.append("xI:")
            buf.append(e.intersect)
            buf.append(" yU:")
            buf.append(e.upper)
            e = e.next
        }
        return buf.toString()
    }
}
